import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ContagemClass } from '../models/common-class';
import {
  ProductsClaimsCompaniesClass,
  ProductsClass,
  ProductsTypesClaimsCausesPDFClass,
  ProductsTypesClass,
} from '../models/products-class';
import { FilesClass } from '../models/uploads-class';
import { HttpclienterrorService } from '../interceptor/httpclienterror.service';
import { ConfigStepperClass, ConfigStepperComponentClass, MailQuoteRequestClass } from '../models/dynamicpdf-class';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  constructor(
    private http: HttpClient,
    public httpclienterrorService: HttpclienterrorService,
  ) {}

  ManagementSetProductsTypesProposalsMailQuoteRequest(
    mailQuoteRequestClass: MailQuoteRequestClass,
    uuid: string,
  ): Observable<MailQuoteRequestClass[]> {
    mailQuoteRequestClass.UUIDLastChange = uuid || '';

    return this.http
      .post<
        MailQuoteRequestClass[]
      >(environment.URL + `/products/ManagementSetProductsTypesProposalsMailQuoteRequest`, mailQuoteRequestClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementGetProductsTypesProposalsMailQuoteRequestID(
    idProductsTypesProposalsMailQuoteRequest: number,
  ): Observable<MailQuoteRequestClass[]> {
    return this.http
      .post<
        MailQuoteRequestClass[]
      >(environment.URL + `/products/ManagementGetProductsTypesProposalsMailQuoteRequestID`, { idProductsTypesProposalsMailQuoteRequest: idProductsTypesProposalsMailQuoteRequest })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementGetProductsTypesProposalsMailQuoteRequestidProd(
    idProductsTypes: number,
  ): Observable<MailQuoteRequestClass[]> {
    return this.http
      .post<
        MailQuoteRequestClass[]
      >(environment.URL + `/products/ManagementGetProductsTypesProposalsMailQuoteRequestidProd`, { idProductsTypes: idProductsTypes })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  HomeGetProductsTypeAll(): Observable<ProductsTypesClass[]> {
    return this.http.get<ProductsTypesClass[]>(environment.URL + `/products/HomeGetProductsTypeAll`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ManagementGetProductsDisableValidation(idProduct: number): Observable<ContagemClass[]> {
    return this.http
      .post<
        ContagemClass[]
      >(environment.URL + `/products/ManagementGetProductsDisableValidation`, { idProduct: idProduct })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementGetProductsTypesDisableValidation(idProductsTypes: number): Observable<ContagemClass[]> {
    return this.http
      .post<
        ContagemClass[]
      >(environment.URL + `/products/ManagementGetProductsTypesDisableValidation`, { idProductsTypes: idProductsTypes })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementGetProductsTypesPurchaseConfigPDFComponentPosition(
    idProductsTypesPurchasePDF: number,
  ): Observable<ConfigStepperComponentClass[]> {
    return this.http
      .post<
        ConfigStepperComponentClass[]
      >(environment.URL + `/products/ManagementGetProductsTypesPurchaseConfigPDFComponentPosition`, { idProductsTypesPurchasePDF: idProductsTypesPurchasePDF })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementSetProductsTypesPurchaseConfigPDFComponentPosition(
    configStepperComponentClass: ConfigStepperComponentClass,
    uuid: string,
  ): Observable<ConfigStepperComponentClass[]> {
    configStepperComponentClass.UUIDLastChange = uuid || '';

    return this.http
      .post<
        ConfigStepperComponentClass[]
      >(environment.URL + `/products/ManagementSetProductsTypesPurchaseConfigPDFComponentPosition`, configStepperComponentClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementGetProductsTypesPurchaseConfigPDF(idProductsTypesProposals: number): Observable<FilesClass[]> {
    return this.http
      .post<
        FilesClass[]
      >(environment.URL + `/products/ManagementGetProductsTypesPurchaseConfigPDF`, { idProductsTypesProposals: idProductsTypesProposals })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementSetProductsTypesPurchaseConfigPDF(
    configStepperComponentClass: FilesClass,
    uuid: string,
  ): Observable<FilesClass[]> {
    configStepperComponentClass.UUIDLastChange = uuid;

    return this.http
      .post<
        FilesClass[]
      >(environment.URL + `/products/ManagementSetProductsTypesPurchaseConfigPDF`, configStepperComponentClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementSetProductsTypesPurchaseConfigStepperComponent(
    productsTypesPurchaseConfigStepperComponentClass: ConfigStepperComponentClass,
    uuid: string,
  ): Observable<ConfigStepperComponentClass[]> {
    if (productsTypesPurchaseConfigStepperComponentClass.extraStepper) {
      return of([]);
    }

    productsTypesPurchaseConfigStepperComponentClass.UUIDLastChange = uuid;
    productsTypesPurchaseConfigStepperComponentClass.JSON = JSON.stringify(
      productsTypesPurchaseConfigStepperComponentClass.JSONArray,
    );

    return this.http
      .post<
        ConfigStepperComponentClass[]
      >(environment.URL + `/products/ManagementSetProductsTypesPurchaseConfigStepperComponent`, productsTypesPurchaseConfigStepperComponentClass)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementSetProductsTypesPurchaseConfigStepper(
    configStepperClass: ConfigStepperClass,
    uuid: string,
  ): Observable<ConfigStepperClass[]> {
    if (configStepperClass.extraStepper) {
      return;
    }

    configStepperClass.UUIDLastChange = uuid;

    return this.http
      .post<
        ConfigStepperClass[]
      >(environment.URL + `/products/ManagementSetProductsTypesPurchaseConfigStepper`, configStepperClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductsTypesPurchaseConfigStepperComponent(
    idProductsTypesPurchaseConfigStepper: number,
  ): Observable<ConfigStepperComponentClass[]> {
    return this.http
      .post<
        ConfigStepperComponentClass[]
      >(environment.URL + `/products/GetProductsTypesPurchaseConfigStepperComponent`, { idProductsTypesPurchaseConfigStepper: idProductsTypesPurchaseConfigStepper })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductsTypesPurchaseConfigStepper(idProductsTypesProposals: number): Observable<ConfigStepperClass[]> {
    return this.http
      .post<
        ConfigStepperClass[]
      >(environment.URL + `/products/GetProductsTypesPurchaseConfigStepper`, { idProductsTypesProposals: idProductsTypesProposals })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  SetProductsTypesClaimsFilesDuplicate(vidProductsClaimsCompanies: number): Observable<FilesClass[]> {
    const dados = {
      idProductsClaimsCompanies: vidProductsClaimsCompanies,
    };

    console.log(dados);
    return this.http.post<FilesClass[]>(environment.URL + `/products/SetProductsTypesClaimsFilesDuplicate`, dados).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetProductsTypesClaimsCompanies(idCompanie: number): Observable<ProductsClaimsCompaniesClass[]> {
    return this.http
      .post<
        ProductsClaimsCompaniesClass[]
      >(environment.URL + `/products/GetProductsTypesClaimsCompanies`, { idCompanie: idCompanie })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductsTypesClaimsCompaniesidCustomer(
    idCompanie: number,
    idCustomer: number,
  ): Observable<ProductsClaimsCompaniesClass[]> {
    return this.http
      .post<
        ProductsClaimsCompaniesClass[]
      >(environment.URL + `/products/GetProductsTypesClaimsCompaniesidCustomer`, { idCompanie: idCompanie, idCustomer: idCustomer })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementSetProductsTypesClaimsFiles(filesClass: FilesClass[]): Observable<FilesClass[]> {
    return this.http
      .post<FilesClass[]>(environment.URL + `/products/ManagementSetProductsTypesClaimsFiles`, filesClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductsTypesClaimsFiles(idProductsClaimsCompanies: number): Observable<FilesClass[]> {
    return this.http
      .post<
        FilesClass[]
      >(environment.URL + `/products/GetProductsTypesClaimsFiles`, { idProductsClaimsCompanies: idProductsClaimsCompanies })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementSetProductsClaimsCompanies(
    productsClaimsCompaniesClass: ProductsClaimsCompaniesClass,
    uuid: string,
  ): Observable<ProductsClaimsCompaniesClass[]> {
    productsClaimsCompaniesClass.UUIDLastChange = uuid;
    return this.http
      .post<
        ProductsClaimsCompaniesClass[]
      >(environment.URL + `/products/ManagementSetProductsClaimsCompanies`, productsClaimsCompaniesClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementGetProductsClaimsCompanies(idCompanie: number): Observable<ProductsClaimsCompaniesClass[]> {
    return this.http
      .get<
        ProductsClaimsCompaniesClass[]
      >(environment.URL + `/products/ManagementGetProductsClaimsCompanies/${idCompanie}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductsTypesClaimsCausesPDF(
    idProduct: number,
    idProductsTypes: number,
    idInsuranceClaimsCausesTypes: number,
    idCompanie: number,
  ): Observable<ProductsTypesClaimsCausesPDFClass[]> {
    return this.http
      .post<
        ProductsTypesClaimsCausesPDFClass[]
      >(environment.URL + `/products/GetProductsTypesClaimsCausesPDF`, { idProduct: idProduct, idProductsTypes: idProductsTypes, idInsuranceClaimsCausesTypes: idInsuranceClaimsCausesTypes, idCompanie: idCompanie })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  // GetProductTypeTemplatePDF(idProductsTypes: number, idProduct: number): Observable<ProductTypeTemplatePDFClass[]> {
  //   return this.http.get<ProductTypeTemplatePDFClass[]>(environment.URL + `/products/GetProductTypeTemplatePDF/${idProductsTypes}/${idProduct}`)
  //     .pipe(
  //       catchError(error => {
  //         this.httpclienterrorService.getServerErrorMessage(error);
  //       return throwError(() => error);
  //       })
  //     );
  // }

  ManagementGetProductsTypesALL(idProduct: number): Observable<ProductsTypesClass[]> {
    return this.http
      .get<ProductsTypesClass[]>(environment.URL + `/products/ManagementGetProductsTypesALL/${idProduct}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementGetProductsTypes(idProduct: number, idProductsTypes: number): Observable<ProductsTypesClass[]> {
    return this.http
      .get<
        ProductsTypesClass[]
      >(environment.URL + `/products/ManagementGetProductsTypes/${idProduct}/${idProductsTypes}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementSetProductsTypes(productsTypesClass: ProductsTypesClass, uuid: string): Observable<ProductsTypesClass[]> {
    productsTypesClass.UUIDLastChange = uuid;
    return this.http
      .post<ProductsTypesClass[]>(environment.URL + `/products/ManagementSetProductsTypes`, productsTypesClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementDuplicateFullProductType(idProductsTypes: number): Observable<ProductsTypesClass[]> {
    return this.http
      .post<ProductsTypesClass[]>(environment.URL + `/products/ManagementDuplicateFullProductType`, {
        idProductsTypes,
      })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementSetProducts(productsClass: ProductsClass, uuid: string): Observable<ProductsClass[]> {
    productsClass.UUIDLastChange = uuid;
    return this.http.post<ProductsClass[]>(environment.URL + `/products/ManagementSetProducts`, productsClass).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ManagementGetProducts(idProduct: number): Observable<ProductsClass[]> {
    return this.http
      .post<ProductsClass[]>(environment.URL + `/products/ManagementGetProducts`, { idProduct: idProduct })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProduct(idProduct: number): Observable<ProductsClass[]> {
    return this.http.post<ProductsClass[]>(environment.URL + `/products/Getproduct`, { idProduct: idProduct }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetProductsClaimsCompanies(idCompanie: number): Observable<ProductsClass[]> {
    return this.http
      .post<ProductsClass[]>(environment.URL + `/products/GetProductsClaimsCompanies`, { idCompanie: idCompanie })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductByCompanie(idCompanie: number, idProduct: number): Observable<ProductsClass[]> {
    return this.http
      .post<
        ProductsClass[]
      >(environment.URL + `/products/GetProductByCompanie`, { idCompanie: idCompanie, idProduct: idProduct })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductsAll(): Observable<ProductsClass[]> {
    return this.http.get<ProductsClass[]>(environment.URL + `/products/Getproductsall`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ManagementGetProductsAll(): Observable<ProductsClass[]> {
    return this.http.get<ProductsClass[]>(environment.URL + `/products/ManagementGetProductsAll`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetProductsOptionsAll(): Observable<ProductsClass[]> {
    return this.http.get<ProductsClass[]>(environment.URL + `/products/GetproductsOptionsall`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetProductsAllByCompanie(idCompanie: number): Observable<ProductsClass[]> {
    return this.http
      .post<ProductsClass[]>(environment.URL + `/products/GetProductsAllByCompanie`, { idCompanie: idCompanie })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductsType(idProduct: number, idProductsTypes: number): Observable<ProductsTypesClass[]> {
    return this.http
      .post<
        ProductsTypesClass[]
      >(environment.URL + `/products/GetProductsType?t=${Date.now()}`, { idProduct: idProduct, idProductsTypes: idProductsTypes })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductsTypeID(idProductsTypes: number): Observable<ProductsTypesClass[]> {
    return this.http
      .post<ProductsTypesClass[]>(environment.URL + `/products/GetProductsTypeID`, { idProductsTypes: idProductsTypes })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductsTypeAll(): Observable<ProductsTypesClass[]> {
    return this.http.get<ProductsTypesClass[]>(environment.URL + `/products/GetProductsTypeAll`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetProductsTypeALLByCompanie(idCompanie: number, idProduct: number): Observable<ProductsTypesClass[]> {
    return this.http
      .post<
        ProductsTypesClass[]
      >(environment.URL + `/products/GetProductsTypeALLByCompanie`, { idCompanie: idCompanie, idProduct: idProduct })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductsTypeALLTree(): Observable<ProductsTypesClass[]> {
    return this.http.get<ProductsTypesClass[]>(environment.URL + `/products/GetProductsTypeALLTree`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetProductsTypeALLTreeShowcase(): Observable<ProductsTypesClass[]> {
    return this.http.get<ProductsTypesClass[]>(environment.URL + `/products/GetProductsTypeALLTreeShowcase`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetProductsTypeChildAll(idProductsTypesOwner: number): Observable<ProductsTypesClass[]> {
    return this.http
      .post<
        ProductsTypesClass[]
      >(environment.URL + `/products/GetProductsTypeChildAll?t=${Date.now()}`, { idProductsTypesOwner: idProductsTypesOwner })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetProductsTypeProductAll(idProduct: number): Observable<ProductsTypesClass[]> {
    return this.http
      .post<
        ProductsTypesClass[]
      >(environment.URL + `/products/GetProductsTypeProductAll?t=${Date.now()}`, { idProduct: idProduct })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }
  GetProductBySlug(slug: string): Observable<ProductsClass[]> {
    return this.http.post<ProductsClass[]>(environment.URL + `/products/GetProductBySlug`, { slug: slug }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  // ═══════════════════════════════════════════════════
  // Summary Sections — Secções dinâmicas do sumário
  // ═══════════════════════════════════════════════════

  GetProductsTypesSummarySections(idProductsTypesProposals: number): Observable<any[]> {
    return this.http
      .post<any[]>(environment.URL + `/products/GetProductsTypesSummarySections`, { idProductsTypesProposals })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementGetProductsTypesSummarySections(idProductsTypesProposals: number): Observable<any[]> {
    return this.http
      .post<
        any[]
      >(environment.URL + `/products/ManagementGetProductsTypesSummarySections`, { idProductsTypesProposals })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ManagementSetProductsTypesSummarySections(section: any): Observable<any[]> {
    return this.http.post<any[]>(environment.URL + `/products/ManagementSetProductsTypesSummarySections`, section).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }
}
